import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { State } from '@/types';
import { emptyStringValues } from '@/utils/objects';

import { TLogoParameters, TLogoEnum, TLogo } from '../types';

import { logosQueryKeys } from './query-keys';
import { useUpdateLogoImage } from './update-logos-images';

export type TPostLogosParams = {
  name: string;
  description?: string | null;
  logos_type: TLogoEnum;
  parameters?: TLogoParameters;
  main_logo: File | string;
  logos: File[] | string[];
  state: State;
};

export async function postLogos(body: TPostLogosParams): Promise<TLogo> {
  return mediaManagerClient.post('/api/v1/logos', emptyStringValues(body));
}

type MutationFn = typeof postLogos;

type TUsePostLogosParams = {
  config?: MutationConfig<MutationFn>;
};

export function usePostLogos({ config = {} }: TUsePostLogosParams = {}) {
  const { t } = useTranslation();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();
  const { mutate: updateLogoImages } = useUpdateLogoImage();

  return useMutation({
    ...config,
    mutationFn: postLogos,
    onError(error) {
      addErrorNotification(t('No se ha podido crear el logo'));
      console.error(error);
    },
    onSuccess(logo, variables) {
      addSuccessNotification(t('El logo se ha creado correctamente'));
      queryClient.invalidateQueries({ queryKey: logosQueryKeys.all });
      if (variables.logos || variables.main_logo) {
        updateLogoImages({
          id: logo.id,
          main_logo: variables.main_logo,
          logos: variables.logos,
          state: variables.state,
        });
      }
    },
  });
}
